import {
  Module,
  VuexModule,
  MutationAction,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import { Group } from '@/api';

@Module({
  name: 'GroupModule',
  namespaced: true,
})
export default class GroupModule extends VuexModule {
  groups: Map<string, string> = new Map();

  @Action({ rawError: true })
  async getGroup(groupName: string) {
    if (!groupName) {
      return null;
    }

    const groupId = this.groups.get(groupName);

    if (groupId) {
      return groupId;
    } else {
      return null;
    }
  }

  @Action
  async init() {
    try {
      const groups = (await Group.all()).data;
      groups.forEach(group => {
        this.groups.set(group.name, group.id);
      });
    } catch {
      // Error
    }
  }
}
